import React from "react";
import { getValue } from "@utils/lodash";

function DownloadSubheaderSvgComponent(props: any) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" 
      height={
        getValue(props, `size`, "") ? getValue(props, `size`, "") : "24px"
      }
      width={
        getValue(props, `size`, "") ? getValue(props, `size`, "") : "24px"
      }
     viewBox="0 0 24 24">
      <defs>
        <clipPath id="clip-path-download">
          <rect id="Rectangle_18194" data-name="Rectangle 18194" width="24" height="24" transform="translate(-14692 -8265)" fill="#fff"/>
        </clipPath>
      </defs>
      <g id="Mask_Group_302" data-name="Mask Group 302" transform="translate(14692 8265)" clip-path="url(#clip-path-download)">
        <path id="download_2_FILL0_wght300_GRAD0_opsz24" d="M5.684-10.158V-11.5h14v1.342Zm6.991-3.476L6.788-20.989H10.18v-6.169h5v6.169h3.392l-5.9,7.356Zm0-2.185,3.021-3.82H13.779v-6.177h-2.2v6.177H9.663ZM12.684-19.639Z" transform="translate(-14692.685 -8234.342)" fill={
          getValue(props, `color`, "")
            ? getValue(props, `color`, "")
            : "#5f6368"
        } />
      </g>
    </svg>
  );
}

export default DownloadSubheaderSvgComponent;
